export * from './login/login.component';
export * from './vendor-register/register.component';
export * from './forget-password/forget-password.component';
export * from './vendor-register-profile/vendor-register-profile.component';
export * from './vendor-register-profile1/vendor-register-profile1.component';
export * from './reset-password/reset-password.component';
export * from './registration-status/registration-status.component';